<template>
  <core-modal-marketing
    tag="Facial Recognition Access"
    :tag-icon="COMMON_ICONS.facialRecognition"
    title="Organize, Discover, and Tell the Stories Behind Your Memories"
    subtitle="Unlock FOREVER AI features that help you find people faster, organize automatically, and enrich the stories behind your photos."
    :header-icon="COMMON_ICONS.facialRecognition"
  >
    <layout-modal-face-rec-upsell
      container-class="p-0"
      hide-header
      :upsell-tracking="upsellTracking"
    />
  </core-modal-marketing>
</template>

<script setup>
  defineProps({
    upsellTracking: Object
  });
</script>
